import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d98463c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "three-d-assembly-parts-card box",
  "data-unit": "three-d-assembly-orderable-parts-card"
}
const _hoisted_2 = { class: "has-text-weight-semibold assembly-parts-title" }
const _hoisted_3 = ["aria-pressed"]
const _hoisted_4 = { class: "assembly-parts-list" }
const _hoisted_5 = ["data-part-key"]
const _hoisted_6 = ["aria-pressed", "disabled", "onClick"]
const _hoisted_7 = { class: "part-name" }
const _hoisted_8 = {
  key: 0,
  class: "part-number"
}
const _hoisted_9 = {
  key: 0,
  class: "child-pricing-loading",
  role: "status",
  "aria-live": "polite",
  "data-unit": "child-pricing-loading"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse" })
], -1))

import { computed } from 'vue'
import { useStore } from 'vuex'
import InfoAddToCart from './info/InfoAddToCart.vue'
import type { ThreeDViewerOrderableAssemblyPart } from '@/interfaces/library'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreeDAssemblyOrderablePartsCard',
  props: {
    assemblyPartNumber: {},
    items: {},
    orderingModeActive: { type: Boolean },
    selectedPartKey: {}
  },
  emits: ['select-part', 'view-parts'],
  setup(__props: any) {





const store = useStore()
const addToCartQtyBehavior = computed(() => store.state.user.preferences.addToCartQtyBehavior)
const displayAvailability = computed(() => store.getters['user/displayAvailability'])
const displayDiscounted = computed(() => store.getters['user/displayDiscounted'])
const displayEta = computed(() => store.getters['user/displayEta'])
const displayRetail = computed(() => store.getters['user/displayRetail'])
const displayWholeSale = computed(() => store.getters['user/displayWholeSale'])
const isCartOrErpCartEnabled = computed(() => store.getters['user/isCartOrErpCartEnabled'])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('threeD.partsOrderableSeparatelyFromAssembly')), 1),
      (_ctx.assemblyPartNumber)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" (" + _toDisplayString(_ctx.assemblyPartNumber) + ") ", 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["button is-primary is-small view-assembly-parts", { 'is-active': _ctx.orderingModeActive }]),
      type: "button",
      "aria-pressed": _ctx.orderingModeActive,
      "data-unit": "view-parts-within-assembly",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-parts')))
    }, _toDisplayString(_ctx.$t('threeD.viewPartsWithinAssemblyForOrdering')), 11, _hoisted_3),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.key,
          class: _normalizeClass(["assembly-part-entry", { 'is-active': item.key === _ctx.selectedPartKey }]),
          "data-part-key": item.key
        }, [
          _createElementVNode("button", {
            class: "button is-white assembly-part-identify",
            type: "button",
            "aria-pressed": item.key === _ctx.selectedPartKey,
            disabled: !_ctx.orderingModeActive,
            onClick: ($event: any) => (_ctx.$emit('select-part', item))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.part.name || item.part.displayName), 1),
            (item.part.partNumberVisible !== false && item.part.partNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.part.partNumber), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6),
          (!item.pricingLoaded)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('loading')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(InfoAddToCart, {
            key: item.key,
            "add-to-cart-qty-behavior": addToCartQtyBehavior.value,
            content: item.part,
            "display-availability": displayAvailability.value,
            "display-discounted": displayDiscounted.value,
            "display-eta": displayEta.value,
            "display-retail": displayRetail.value,
            "display-whole-sale": displayWholeSale.value,
            "is-cart-or-erp-cart-enabled": isCartOrErpCartEnabled.value,
            pricing: { ...item.part, isLoaded: item.pricingLoaded },
            "show-pricing-for-parts": ""
          }, null, 8, ["add-to-cart-qty-behavior", "content", "display-availability", "display-discounted", "display-eta", "display-retail", "display-whole-sale", "is-cart-or-erp-cart-enabled", "pricing"]))
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})